<template>
  <vue-context
    ref="contextMenu"
    :close-on-click="closeOnClick"
    class="base-context-menu"
    :lazy="true"
    @open="$emit('open')"
    @close="onClose"
  >
    <!-- class="contextual-menu image-row__actions" -->
    <!-- <template v-slot:default="{data}"> -->
    <template
      v-for="(element, index) in items"
    >
      <!-- for submenus -->
      <base-hover
        v-if="isButton(element)"
        :key="`menu_element_${index}`"
        v-slot="{ isHover }"
      >
        <button
          class="menu-item"
          :class="`${index === 0 ? 'pt-3' : index === items.length - 1 ? 'pb-3' : ''} ${element.class || ''}`"
          @mouseover="isSubmenu(element) ? openSubmenu(`submenu_${index}`) : () => {}"
          @mouseleave="isSubmenu(element) ? closeSubmenu(`submenu_${index}`) : () => {}"
          @click.prevent="isSubmenu(element) ? openSubmenu(`submenu_${index}`) : element.action()"
          @contextmenu.prevent="isSubmenu(element) ? openSubmenu(`submenu_${index}`) : element.action()"
        >
          <!-- @click.prevent="element.action" -->
          <!-- :class="` ${element.label === 'Paste' && !clipboardHasImage ? '--disabled' : ''} `" -->
          <div class="menu-item__icon">
            <base-icon
              :icon="`${element.icon}`"
              :class="`${element.iconSmall ? 'base-icon--small' : ''}`"
            />
          </div>
          <div
            v-if="element.label.length"
          >
            {{ element.label }}
          </div>
          <!-- recursive submenu -->
          <template v-if="isSubmenu(element)">
            <base-context-menu
              :ref="`submenu_${index}`"
              class="submenu"
              :items="element.items"
              close-on-click
            />
            <base-icon
              icon="submenu-arrow-right"
              class="submenu-arrow-right"
            />
          </template>
        </button>
      </base-hover>

      <!-- Special submenu elements -->
      <!-- divider -->
      <hr
        v-else-if="element.key === 'divider'"
        :key="`menu_element_${index}`"
        :class="element.class"
        :style="`${element.style}`"
      >
      <!-- fallback -->
      <div
        v-else
        :key="`menu_element_${index}`"
        class="d-none"
      />
    </template>

    <!-- </template> -->
  </vue-context>
</template>
<script>
import { VueContext } from 'vue-context';

export default {
  name: 'BaseContextMenu',
  components: { VueContext },
  props: {
    /** Context menu items.
    Each item contains:
      [mandatory] label: Label to show
      [mandatory] action: (function) what to do when clicking this item
      [optional] icon: (string) name of the icon to prepend
    */
    items: {
      type: Array,
      required: true,
    },
    // validator: items => (items.every(['label', 'action'].map(key => key in items)))
    /** Display or not */
    // value: {
    //   type: Boolean,
    //   default: false
    // }
    closeOnClick: {
      type: Boolean,
      default: true,
    },
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        if (this.alwaysOpen && !newVal) this.show();
      },
    },
  },
  methods: {
    show(event) {
      this.$nextTick().then(() => {
        this.$refs.contextMenu.open(event ?? new Event('click'), this.items);
      });
    },
    onClose() {
      if (this.alwaysOpen) {
        this.show();
      } else this.$emit('input', false);
    },
    isButton(elem) {
      return ['label', 'action'].every((key) => key in elem) || this.isSubmenu(elem);
    },
    isSubmenu(elem) {
      return elem.items && elem.items.length;
    },
    openSubmenu(ref) {
      this.$nextTick().then(() => {
        this.$refs[ref][0].show();
      });
    },
    closeSubmenu(ref) {
      this.$nextTick().then(() => {
        const submenu = this.$refs[ref][0];
        submenu.close();
      });
    },
    close() {
      this.$nextTick().then(() => {
        this.$refs.contextMenu.close();
        this.$emit('input', false);
      });
    },
    // showXY(x, y) {
    //   console.log("Showing context menu in X: ", x, "Y: ", y)
    //   this.$nextTick().then(() => {
    //     this.$refs.contextMenu.open(new Event('click'), this.items, x, y)
    //   })
    // }
  },
  // watch: {
  //   value(newVal) {
  //     console.log("Showing context menu? ", newVal)
  //     this.$nextTick().then(() => {
  //       if (newVal) {
  //         this.$refs.contextMenu.open();
  //       }
  //     })
  //   }
  // }
};

const elements = {
  divider: {
    key: 'divider',
    class: 'mx-3 my-2',
    style: 'border-color: rgba(black, 0.25);',
  },
};
export { elements };

</script>
<style lang="scss"
  scoped>
@import '~vue-context/dist/css/vue-context.css';

.vue-context {
  padding: unset !important;
}

$border-radius: 8px;
$hover-pink: #ECE9E7;
$outline-padding: 8px;

.base-context-menu {
  border: unset !important;
  border-radius: $border-radius !important;
  background: $gray-light !important;
  overflow: visible;
  min-width: 200px;
  padding-top: $outline-padding !important;
  padding-bottom: $outline-padding !important;

  &:hover {
    background: $gray-light !important;
  }
  .menu-item {
    color: $black;
    width: 100%;
    border: 1px solid transparent;
    padding: 11px 20px;
    background-color: transparent;
    transition: background-color 0.2s ease;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;

    &:hover {
      background-color: $hover-pink;
    }

    &__icon {
      width: 28px;
    }

    &--outlined:not(:hover) {
      border: 1px solid $gray-light-4;
      border-radius: $border-radius;
      margin-left:$outline-padding;
      width: calc(100% - ( 2 * #{$outline-padding}) );
      padding-left: calc(20px - #{$outline-padding} );

      >.base-context-menu {
        margin-left: unset;
      }
    }
  }

  & > div {
    overflow: hidden;
    // Avoids removing main 'overflow: visible'. Using "hidden" messes up submenus
    &:first-child {
      border-top-left-radius: $border-radius;
      border-top-right-radius: $border-radius;
    }
    &:last-child {
      border-bottom-left-radius: $border-radius;
      border-bottom-right-radius: $border-radius;
    }
  }
  font-size: 13px;
  //padding: 22px 20px; //12px;
  z-index: 1041;
}
.submenu-arrow-right {
  position: absolute;
  right: 5px;
  transform: translateX(-200%);
}

::v-deep .base-icon {
  &--small {
    transform: scale(0.7);
    height: 22px !important;
  }
}
.submenu {
  transform: unset !important;
  left: calc(100% + 4px);
  // Little "bridge" for the mouse, to avoid mouseleave event so the menu stays open.
  &:before {
    position: absolute;
    background-color: transparent;
    left: -15px;
    width: 15px;
    height: 100%;
    content: "";
  }
  top: unset !important;
}

</style>
